export default __webpack_public_path__ + "static/media/aluminium-bell.d8897bef.jpg";